const auction_adding = {
  select_date:"Wybierz datę",
  operation_time:"Czas operacji",
  select_time:"Wybierz godzinę",
  select_date_first:"Najpierw wybierz datę",
  price_per_km:"Cena za kilometr",
  max_surcharges:"Maksymalna ilość dopłat to 10",
  min_value:"Minimalna wartośc to",
  max_value:"Maksymalna wartość to",
  no_krs:"Nie można dodać ogłoszenia bez dokumentów CEIDG.",
  surcharge_error:"Tytuł dopłaty musi mieć max 200 znaków. Wartość dopłaty musi być mniejsza niż 1000000000.",
  distance:"Dystans",
  license:"Wymagana licencja",
  flat_rate: "Ryczałt - Pauschal",
  payment_deadline:"Termin płatności",
  pick_currency:"Wybierz walutę",
  address_not_specific:"Ten adres nie jest wystarczająco dokładny. Proszę podać dokładniejszy adres.",
  doc_nr: "Numer zlecenia",
  settings: "Ustawienia ogłoszenia",
  default: " Domyślny termin płatności",
  threshold: "Minimalny próg przebijania kwoty (opcjonalne)",
  default_threshold: "Domyślna wartość progu przebijania to 1",
  threshold_placeholder: "Wpisz próg przebijania",
  add: "Dodaj aukcję",
  pick_start_point: "Wybierz punkt początkowy",
  pick_end_point: "Wybierz punkt końcowy",
  add_middle_point: "Dodaj punkt pośredni",
  choose_middle_point: "Wybierz punkt pośredni",
  load_error_1: "Wymagany jest co najmniej 1 ładunek",
  load_error_2: "Uzupełnij rodzaj frachtu.",
  load_error_3: "Dane ładunku są niepoprawne.",
  warehouse_address_error: "Podany adres jest zbyt mało dokładny",
  dates_chronological: "Uwaga! Daty w trasie nie są ustawione w chronologiczny sposób. Aby dodać aukcję, ustaw daty tak, aby następowały po sobie.",
  cargos_empty: "Uwaga! Uzupełnione części ładunku nie mogą być puste ani nie mogą być zerem.",
  ramps_empty: "Uwaga! Musisz uzupełnić wszystkie wymagane rampy.",
  start_missing: "Wszystkie dane w punkcie początkowym muszą być wypełnione.",
  middle_missing: "Wszystkie dane w punktach pośrednich muszą być wypełnione.",
  end_missing: "Wszystkie dane w punkcie końcowym muszą być wypełnione.",
  operation_missing: "Wszystkie punkty muszą mieć dodaną operację.",
  full_cargo_transport_info: "Transport obejmuje cały ładunek - wszystkie pozycje będą przewożone razem",
  choose_address: "Wybierz adres",
  address_placeholder: "Wpisz adres...",
  choose_address_required: "Wybierz adres",
  operation_date: "Data operacji",
  choose_date_required: "Wybierz datę",
  cargo_operations: "Operacje na ładunku",
  loading_all_cargo: "Załadunek całego ładunku",
  unloading_all_cargo: "Rozładunek całego ładunku",
  full_cargo_note: "Wszystkie pozycje ładunku będą przewożone razem",
  start_date_before_end: "Data startu musi być wcześniejsza niż data rozładunku",
};
export default auction_adding;
